export default {"src":"/_next/static/media/dough.d4c10173.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};